import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import { Building2, CreditCard, Hash, User } from 'lucide-react'

import { CopiableContactField } from '@/components/research-bar/copiable-contact-field'
import {
  BANK_ACCOUNT_HOLDER,
  BANK_BIC,
  BANK_IBAN,
  BANK_NAME,
  REUNION_BANK_ACCOUNT_HOLDER,
  REUNION_BANK_BIC,
  REUNION_BANK_IBAN,
  REUNION_BANK_NAME,
} from '@/lib/constants/agency'

interface BankTransferDetailsProps {
  isReunion?: boolean
  paymentDeadline?: string
}

export function BankTransferDetails({
  isReunion,
  paymentDeadline,
}: BankTransferDetailsProps) {
  const accountHolder = isReunion ? REUNION_BANK_ACCOUNT_HOLDER : BANK_ACCOUNT_HOLDER
  const iban = isReunion ? REUNION_BANK_IBAN : BANK_IBAN
  const bic = isReunion ? REUNION_BANK_BIC : BANK_BIC
  const bankName = isReunion ? REUNION_BANK_NAME : BANK_NAME
  const deadlineFormatted = paymentDeadline
    ? format(paymentDeadline, 'd MMMM yyyy', { locale: fr })
    : null

  return (
    <div className="flex w-full flex-col gap-4">
      {deadlineFormatted && (
        <div className="flex flex-col gap-0.5 sm:flex-row sm:items-center sm:justify-between">
          <div className="text-gray-light-700 text-sm font-medium">
            Date limite de réception du virement
          </div>
          <div className="text-gray-light-900 text-sm font-semibold">{deadlineFormatted}</div>
        </div>
      )}
      {/* Un champ par ligne en mobile ; l'IBAN garde la pleine largeur partout */}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <CopiableContactField icon={User} label="Nom" value={accountHolder} />
        <CopiableContactField icon={Building2} label="Banque" value={bankName} />
        <div className="sm:col-span-2">
          <CopiableContactField icon={CreditCard} label="IBAN" value={iban} />
        </div>
        <CopiableContactField icon={Hash} label="Code BIC" value={bic} />
      </div>
    </div>
  )
}
